import { apiClient } from "../apiClient";

export const BIEU_MAU_NGUOI_DUNG_ENDPOINT = "bieu-mau-nguoi-dung";
export const bieuMauNguoiDungApi = {
    SelectAll: () => apiClient.get(`${BIEU_MAU_NGUOI_DUNG_ENDPOINT}`),
    Insert: (payload: any) => apiClient.post(BIEU_MAU_NGUOI_DUNG_ENDPOINT, payload),
    Update: (id: number, payload: any) => apiClient.put(`${BIEU_MAU_NGUOI_DUNG_ENDPOINT}/${id}`, payload),
    Delete: (id: number) => apiClient.delete(`${BIEU_MAU_NGUOI_DUNG_ENDPOINT}/${id}`),
    SelectFieldsByChucNang: (ma_chuc_nang: string) => apiClient.get(`${BIEU_MAU_NGUOI_DUNG_ENDPOINT}/field/chuc-nang/${ma_chuc_nang}`),
}